<template>
  <TEIButton
    :text="$t('Start Over')"
    @click="onStartOverButtonClicked()"
    color="neutral"
    class="tei-start-over-button"
    :small="small"
  >
    <CaretRightIcon class="tei-layout-container__button-icon" />
  </TEIButton>
</template>

<script>
import { mapActions } from 'pinia';
import TEIButton from '@/components/teis/TEIButton.vue';
import * as types from '@/lib/constants/store';
import CaretRightIcon from '@/components/ui-elements/texas-icons/CaretRightIcon.vue';
import {
  useModalStore,
} from '@/stores';

export default {
  name: 'TEIStartOverButton',
  components: {
    TEIButton,
    CaretRightIcon,
  },
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions(useModalStore, [
      types.OPEN_MODAL,
    ]),
    onStartOverButtonClicked() {
      this[types.OPEN_MODAL]({
        type: 'TEIStartOverModal',
        id: 'TEIStartOverModal',
      });
    },
  },
};
</script>

<style lang="stylus">
.tei-start-over-button {
  &:focus {
    background-color: $nebula-color-platform-interactive-200;
  }
}
</style>
